import UserApiKeyResourceModel from '../../generated/types/model/resource/UserApiKeyResourceModel';

export default class UserApiKeyResourceViewModel extends UserApiKeyResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
